import template from './time_management_setup.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class TimeManagementSetupViewModel
{
	constructor (page)
	{
		this.page = page;
		this.loader = ko.observable(false);
		this.table_report = ko.observableArray();
		this.download_data = ko.observableArray();
		this.manager = ko.observableArray([]);
		this.employee_id = ko.observable();
		this.from_filter =ko.observable(Utils.toJSONDateString(new Date(new Date().setFullYear(new Date().getFullYear() - 1)))); 
		this.to_filter = ko.observable(Utils.toJSONDateString(new Date()));
		this.approval_structure = ko.observableArray([]);
		this.transaction_types = ko.observableArray([]);
		this.projects = ko.observableArray([]);

		this.current_page_number = ko.observable(1);
		this.page_count = ko.observable(1);
		this.current_page_size = ko.observable(10);
		this.number_of_records = ko.observableArray([10, 20, 50, 100]);
		this.selected_number_of_records = ko.observable(10);
		this.pagination_summary = ko.observable('');       
        // Sorting
		this.sort_field_tt = ko.observable('user_description');
		this.sort_order_tt = ko.observable('ASC');
		
		this.sort_field_pt = ko.observable('task_description');
		this.sort_order_pt = ko.observable('ASC');
		this.selected_number_of_records.subscribe((newVal) => {
			this.current_page_size(newVal);
			this.page.loadTable();
		});

		//options
		this.selected_display = ko.observable('time_logged_rg'); 
		this.selected_search = ko.observable('employee_rg'); 

		this.summary_total_hours = ko.observable(0);
		this.summary_employees_count = ko.observable(0)
		this.table_visible = ko.observable(false);

		this.current_department_id = ko.observable();
		this.current_company_id = ko.observable();

		this.selected_company = ko.observable();
		this.selected_department = ko.observable();

		this.selected_company.subscribe((newValue) => {
			if (newValue != null)
			{
				this.current_company_id(newValue.company_id);
				this.page.updateData();
			}
			else
			{
				this.current_company_id(null);
				this.page.updateData();
			}
		});

		this.selected_department.subscribe((newValue) => {
			if (newValue != null)
			{
				this.current_department_id(newValue.department_id);
				this.page.updateData();
			}
			else
			{
				this.current_department_id(null);
				this.page.updateData();
			}
		});
	}

	sort_column(column)
	{
		if (column && column.trim() !== '')
		{
			if (this.sort_field_tt() === column)
				this.sort_order_tt(this.sort_order_tt() === 'ASC' ? 'DESC' : 'ASC');
			else
			{
				this.sort_field_tt(column);
				this.sort_order_tt('ASC');
			}
			this.page.load_transaction_types();
		}

		if (column && column.trim() !== '')
		{
			if (this.sort_field_pt() === column)
				this.sort_order_pt(this.sort_order_pt() === 'ASC' ? 'DESC' : 'ASC');
			else
			{
				this.sort_field_pt(column);
				this.sort_order_pt('ASC');
			}
			this.page.load_projects();
		}
		
	}

	page_click(page_number)
	{
		this.current_page_number(page_number);
		this.page.load_transaction_types();
		this.page.load_projects();
	}

	async edit_project(row)
	{
		await Grape.dialog.open("EditProject", { row: row });
		this.page.load_projects();
	}

	async edit_entry_approval_structure(row)
	{
		row.department_id = this.current_department_id(); 
		await Grape.dialog.open('AddApprovalStructure', { row: row });
		this.page.load_entries();
	}

	async delete_transaction_type(row)
	{
		let response = await Grape.alerts.confirm({type: "warning", title: tr("Warning"),
			message: tr("Are you sure you want to delete the entry? This will remove all the time that has been logged for this entry and may be a dangerous action.")});
			
		if (response)
		{
			let res = await Grape.fetches.postJSON("/payroll_integration/user_transaction_type_remove", { id: row.id });
			
			if (res.status == "OK")
			{
				Grape.alerts.alert({type: "success", message: tr("Successfully removed user transaction type."), title: tr("Success")});
				this.page.updateData();
			}
			else if (res.status == "ERROR")
			{
				Grape.alerts.apiError(res);
				this.page.updateData();
			}
			else if (res.error)
			{
				Grape.alerts.alert({type: "error", message: res.error, title: tr("Error")});
				this.page.updateData();
			}
			else
				Grape.alerts.alert({type: "error", message: tr("Something went wrong..."), title: tr("Error")});
		}
	}

	show_report_help()
	{
		Grape.dialog.open('ApprovalStructureHelp', { employee_id: this.page.bindings.id });
	}

	show_projects_help()
	{
		Grape.dialog.open("ApprovalStructureHelp", { employee_id: this.page.bindings.id });
	}

	async edit_transaction_type(row)
	{
		let payrollDescription = row.payroll_description;
		await Grape.dialog.open("EditTransactionType", { ...row, payrollDescription });
		this.page.load_transaction_types();
	}

	async add_user_transaction_type()
	{
		await Grape.dialog.open("EditTransactionType", { company_id: this.current_company_id() });
		this.page.load_transaction_types();
	}

	async add_project()
	{
		await Grape.dialog.open("EditProject", { company_id: this.current_company_id() });
		this.page.load_projects();
	}

	async delete_entry(row)
	{
		let response = await Grape.alerts.confirm({type: "warning", title: tr("Warning"), message: tr("Are you sure you want to delete the entry?")});

		if (response)
		{
			let res = await Grape.fetches.postJSON("/time_management/remove_approval_structure_line", { approval_structure_line_id: row.approval_structure_line_id, });
			if (res.status == "OK")
			{
				Grape.alerts.alert({type: "success", message: tr("Successfully removed approval structure line."), title: tr("Success")});
				this.page.load_entries();
			}
			else if (res.status == "ERROR")
			{
				Grape.alerts.apiError(res);
				this.page.load_entries();
			}
			else if (res.error)
			{
				Grape.alerts.alert({type: "error", message: res.error, title: tr("Error")});
				this.page.updateData();
			}
			else
				Grape.alerts.alert({type: "error", message: tr("Something went wrong..."), title: tr("Error")});
		};
	};

	async add_approval_structure()
	{ 
		await Grape.dialog.open('AddApprovalStructure', { department_id: this.current_department_id() });
		this.page.load_entries();
	}

	async log_time()
	{
		let employee_id = Utils.get_local_storage_nullable('employee_id');
		await Grape.dialog.open('LogTime', { employee_id: employee_id });
		this.page.load_entries();
	}

	async delete_project(row)
	{
		let response = await Grape.alerts.confirm({type: "warning", title: tr("Warning"), message: tr("Are you sure you want to delete the entry?")});
		if (response)
		{
			let res = await Grape.fetches.postJSON("/time_management/remove_project_task", { task_id: row.task_id });
			if (res.status == "OK")
			{
				Grape.alerts.alert({type: "success", message: tr("Successfully removed project."), title: tr("Success")});
				this.page.updateData();
			}
			else if (res.status == "ERROR")
			{
				Grape.alerts.apiError(res);
				this.page.updateData();
			}
			else if (res.error)
			{
				Grape.alerts.alert({type: "error", message: res.error, title: tr("Error")});
				this.page.updateData();
			}
			else
				Grape.alerts.alert({type: "error", message: tr("Something went wrong..."), title: tr("Error")});
		}
	}
}

class TimeManagementSetupPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new TimeManagementSetupViewModel(this);
	}

	init()
	{
		document.title = tr('Time Management Setup');
		window.current_page_title(tr('Time Management Setup'));

		this.viewModel.employee_id(Utils.current_employee_id())
		this.load_projects();
	}

	updateData()
	{
		this.load_entries();
		this.load_transaction_types();
		this.load_projects();
	}

	async load_entries()
	{
		this.viewModel.loader(true);

		this.viewModel.table_visible(false); 
		this.viewModel.loader(false);
		await this.load_approval_structure(); 
	}

	set_table_query_options()
	{
		let table_query_options = {
			offset: 0,
			limit: 1000000000,
			department_id: this.viewModel.current_department_id(),
			company_id: this.viewModel.current_company_id(),
		};
		return table_query_options;
	}

	async load_approval_structure()
	{
		if (!this.viewModel.current_department_id()) return;
		let table_query_options = this.set_table_query_options();

		if (!table_query_options) return;
		table_query_options.sortfield = "priority";
		table_query_options.sortorder = "ASC";
		let res = await Grape.fetches.postJSON("/time_management/get_approval_structure_line", table_query_options);
		if (res.report.time_logged != null)
		{
			res.offset = res.report.time_logged.length;
			res.records = res.report.time_logged;
			res.total = res.report.count;
			this.viewModel.table_visible(true);
			this.viewModel.approval_structure(res.report.time_logged);
		}
		else
		{
			this.viewModel.approval_structure([]);
			this.viewModel.table_visible(true);
		}
	}

	async load_projects()
	{
		let table_query_options = this.set_table_query_options();
		if (!table_query_options) return;

		table_query_options.sortField = "task_description";
		table_query_options.sortOrder = "ASC";

		table_query_options.schema = "savanna";
		table_query_options.table = "v_projects";

		if (this.viewModel.current_company_id())
			table_query_options.filter = [{
				value: this.viewModel.current_company_id(),
				op: "=",
				field: "company_id",
			}];

		let res = await Grape.fetches.getJSON("/api/record", table_query_options)
		if (res.status !== 'ERROR')
			this.viewModel.projects(res.records)
		else
			this.viewModel.projects([]);
	}

	async load_transaction_types()
	{
		if (!this.viewModel.current_company_id()) return;
		let table_query_options = this.set_table_query_options();

		if (!table_query_options) return;

		table_query_options.sortField = "transaction_type_id";
		table_query_options.sortOrder = "ASC";

		table_query_options.table = "v_transaction_types_user";
		table_query_options.schema = "savanna";
		table_query_options.offset = (this.viewModel.current_page_number() - 1) * this.viewModel.current_page_size();
		table_query_options.limit = this.viewModel.current_page_size();
		table_query_options.sortfield = this.viewModel.sort_field_tt();
		table_query_options.sortorder = this.viewModel.sort_order_tt();
		table_query_options.filter = [{
				value: this.viewModel.current_company_id(),
				operand: "=",
				field: "company_id",
			},
			{ value: "true", op: "=", field: "active" }];

		let res = await Grape.fetches.getJSON("/api/record", table_query_options);
		if (res.status !== 'ERROR')
			this.viewModel.transaction_types(res.records);
		else
			this.viewModel.transaction_types([]);
	}
}

export default {
	route: '[/]time_management/time_management_setup',
	page_class: TimeManagementSetupPage,
	template: template,
	template_filename: 'translation/time_management_setup'
};
